var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAeroplane = function SvgAeroplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.026 10.476 2.897.241A2.11 2.11 0 0 0 .723.37c-.313.225-.54.533-.65.882s-.095.72.04 1.061l3.358 8.52a.45.45 0 0 0 .176.211.5.5 0 0 0 .277.082h8.626c.248-.003.488.079.672.23.184.15.298.36.32.584a.8.8 0 0 1-.056.35.9.9 0 0 1-.203.3 1 1 0 0 1-.317.202c-.12.047-.25.071-.38.07H3.923a.52.52 0 0 0-.277.083.45.45 0 0 0-.176.211l-3.357 8.52c-.101.263-.131.543-.089.819s.157.537.333.764.41.413.681.541a2.08 2.08 0 0 0 1.81-.018l20.177-10.268c.296-.152.542-.373.713-.64s.261-.57.261-.88c0-.308-.09-.612-.261-.878a1.85 1.85 0 0 0-.713-.64"
  })));
};
export default SvgAeroplane;